module.exports = __webpack_public_path__ + "img/finger.702f8e57.svg";